import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Link } from "react-router-dom";
import { NotificationManager } from "react-notifications";

import SelectSourceForm from "./selectSourceForm";
import PaginatedTable from "../../../../sharedComponents/tableWithPagination";
import FilterPanel, { PanelBody } from "../../../../sharedComponents/filterPanel";
import { getRecipeSourceList, removeRecipeSource, addRecipeSources } from "../../../../store/actions";
import ConfirmDelete from "../../../../sharedComponents/confirmDelete";

const Sources = ({
	recipeDetails,
	setActiveTab,
	getRecipeSourceList,
	removeRecipeSource,
	recipeSourceList,
	addRecipeSources,
	newAdditions
}) => {
	useEffect(() => {
		recipeDetails.id && getRecipeSourceList(recipeDetails.id);
	}, [recipeDetails, getRecipeSourceList]);

	const [submitting, setSubmitting] = useState(false);
	const [recipeSources, updateRecipeSources] = useState([]);
	useEffect(() => {
		updateRecipeSources(recipeSourceList);
	}, [recipeSourceList]);

	useEffect(() => {
		newAdditions("sources", recipeSources.filter((item) => item.isNew).length > 0);
	}, [recipeSources, newAdditions]);

	const removeSource = (original) => {
		const successHandler = () => updateRecipeSources(recipeSources.filter((item) => item.source !== original.source));
		if (!original.isNew) {
			removeRecipeSource(original.id, successHandler);
		} else {
			successHandler();
		}
	};

	const columns = [
		{
			Header: "Seq",
			accessor: "seq",
			width: 100
		},
		{
			Header: "Name",
			id: "name",
			accessor: (d) => {
				return d.source_data;
			},
			Cell: ({ value }) => {
				return <span>{value.name}</span>;
			}
		},
		{
			Header: "URL",
			id: "url",
			accessor: (d) => {
				return d.source_data;
			},
			Cell: ({ value }) => {
				const { url, url_title } = value;
				return <Link to={url}>{url_title}</Link>;
			}
		},
		{
			Header: "Notes",
			id: "notes",
			accessor: (d) => {
				return d.source_data;
			},
			Cell: ({ value }) => {
				return <span>{value.notes}</span>;
			}
		},
		{
			Header: "Actions",
			id: "actions",
			className: "text-right",
			headerClassName: "text-right",
			width: 100,
			accessor: (d) => {
				return d.id;
			},
			Cell: ({ original }) => (
				<button
					type="button"
					onClick={() => confirmDelete(original)}
					className="btn btn-danger btn-ghost btn-sm btn-cell">
					<i className="icon icon-trash" />
				</button>
			),
			sortable: false
		}
	];

	const [showAddSourcePanel, toggleAddSourcePanel] = useState(false);

	const addToRecipeSources = (event) => {
		const newSource = {
			id: null,
			recipe: recipeDetails.id,
			seq: event.seq,
			source: event.source,
			source_data: { ...event.source_data },
			isNew: true
		};
		updateRecipeSources([...recipeSources, newSource]);
	};

	const addSources = () => {
		const newSources = recipeSources.filter((item) => !item.id);
		const listItems = newSources.map((item) => ({
			recipe: recipeDetails.id,
			seq: item.seq,
			source: item.source
		}));
		const successHandler = (event) => {
			setSubmitting(false);
			if (event.status >= 200 && event.status < 300) {
				getRecipeSourceList(recipeDetails.id);
				NotificationManager.success("Successfully added!", "", 5000);
				setActiveTab(4);
			} else {
				NotificationManager.error("Please try again!", "", 5000);
			}
		};
		if (listItems.length) {
			setSubmitting(true);
			addRecipeSources(listItems, successHandler);
		} else {
			setActiveTab(4);
		}
	};

	const [deleteItem, setDeleteItem] = useState(null);
	const confirmDelete = (original) => {
		setDeleteItem(original);
	};
	const confirmEvent = (yes) => {
		setDeleteItem(null);
		yes && removeSource(deleteItem);
	};

	return recipeDetails && recipeDetails.id ? (
		<React.Fragment>
			<div className="p-4">
				<div className="row">
					<div className="col-12">
						<div className="d-flex align-items-center">
							<h4 className="flex-fill m-0">Source Listing</h4>
							<button
								type="button"
								onClick={() => toggleAddSourcePanel(true)}
								className="btn btn-primary text-uppercase">
								<i className="icon icon-plus" /> Add new
							</button>
						</div>
						<div className="table-container">
							{recipeSources && recipeSources.length ? (
								<PaginatedTable data={recipeSources} columns={columns} />
							) : (
								<div className="alert alert-info text-center mt-3">No Source selected!</div>
							)}
						</div>
					</div>
				</div>
				<div className="tab-footer row pt-3">
					<div className="col-12 text-right">
						<button type="button" className="btn btn-default" onClick={() => setActiveTab(2)}>
							Back
						</button>
						<button
							type="button"
							className="btn btn-primary-dark"
							onClick={addSources}
							disabled={!recipeSources.length || submitting}>
							Save &amp; Next
						</button>
					</div>
				</div>
			</div>
			<ConfirmDelete item={deleteItem} message={<div>Are you sure you want to delete?</div>} onEvent={confirmEvent} />
			<FilterPanel
				className="add-category-panel"
				show={showAddSourcePanel}
				toggle={() => toggleAddSourcePanel(!showAddSourcePanel)}
				title="Add Sources"
				closeBtn>
				<PanelBody className="d-flex flex-column">
					<SelectSourceForm
						recipeSourceList={recipeSources}
						togglePanel={(event) => toggleAddSourcePanel(event)}
						initialValues={{ seq: recipeSources.length + 1 }}
						onUpdate={addToRecipeSources}
					/>
				</PanelBody>
			</FilterPanel>
		</React.Fragment>
	) : null;
};

const mapStateToProps = (state) => {
	return {
		recipeDetails: get(state, "Recipes.recipeDetails", []),
		recipeSourceList: get(state, "AddRecipe.recipeSourceList.results", [])
	};
};

const mapDispatchToProps = {
	getRecipeSourceList,
	addRecipeSources,
	removeRecipeSource
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Sources);
